import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

const L = {
  it: { t: "Pagamento annullato", d: "Hai annullato il pagamento. Nessun importo è stato addebitato. Puoi riprovare quando vuoi.", back: "Torna ai piani" },
  en: { t: "Payment cancelled", d: "You cancelled the payment. No amount was charged. You can try again whenever you like.", back: "Back to pricing" },
};

export default function PaymentCancel() {
  const navigate = useNavigate();
  const lang = localStorage.getItem("thoth_lang") || "it";
  const t = L[lang];
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center fade-up bg-[#141B27] border border-white/8 rounded-3xl p-8 shadow-2xl" data-testid="payment-cancel-page">
        <div className="w-16 h-16 rounded-2xl bg-slate-500/15 border border-slate-500/30 grid place-items-center mx-auto">
          <XCircle className="w-9 h-9 text-slate-400" />
        </div>
        <h1 className="font-head font-extrabold text-2xl mt-5">{t.t}</h1>
        <p className="text-slate-400 mt-2">{t.d}</p>
        <button onClick={() => navigate("/")} data-testid="payment-cancel-back" className="mt-7 w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 py-3 rounded-xl font-semibold transition-colors">
          <ArrowLeft className="w-4 h-4" /> {t.back}
        </button>
      </div>
    </div>
  );
}
